<template>
	<v-container fluid class="pa-0" style="height: calc(100vh - 205px);">
		<v-row>
			<v-col cols="12" class="pb-10">
				<v-card v-for="(item, index) in items" :key="item.id"
				outlined
				:class="`${index===0?items.length===1?'':'rounded-b-0':index===items.length-1?'rounded-t-0':'rounded-0'}`"
				:style="`${index===0?items.length===1?'':'border-bottom: 0':index===items.length-1?'':'border-bottom: 0'}`"
				@click="$emit('show-detail', item)">
					<v-card-text class="pa-0">
						<v-row class="ma-0">
							<v-col cols="7">
								<span class="d-block w-100 truncate" style="color: #424242; font-size: 14px;">{{ item.name }}</span>
								<span class="d-block w-100" style="color: grey">{{ formatLongDate(item.creationDate) }}</span>
							</v-col>
							<v-col cols="5" class="d-flex align-center justify-end">
								<div>
									<span class="d-block w-100 black--text text-body-1 font-weight-bold text-right">{{ formatCurrency(item.amount) }}</span>
									<span :style="`display: block; white-space: nowrap; overflow: visible; color: ${getStatusColor(item.status)}`">{{ getStatusText(item.status) }}</span>
								</div>
								<v-icon class="ml-4">chevron_right</v-icon>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import BaseModule from '../../common/BaseModule.js'

export default {
	name: 'ExpenseSheetCardList',
	mixins: [BaseModule],
	props: ['items'],
	components: {
	},
	data () {
		return { 
			options: { itemsPerPage: 20 },
		}
    },
	methods: {
		searchTimeOut() {
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
			this.timer = setTimeout(() => {
				this.options.page = 1;
				this.getItems();
			}, 800);
		},
	},
	watch: {
		options: {
			handler () {
				this.$log.debug(this.options);
				this.$emit('refresh');
			},
			deep: true,
		},
	},
}
</script>

